<template lang="pug">
  .col-24.flexD.alignItemsCenter.justifyCenter.l-padding-top-6em.l-padding-bottom-6em.m-padding-bottom-4em.m-padding-top-4em
    .col-16.flexD.flexDirectionRow.minWidth768.justifySpaceAround.m-minWidthAuto.m-width-90.flexWrap
      .col-11.flexD.justifyCenter.flexDirectionColumn.alignItemsCenter.justifyCenter.m-width-100.m-margin-bottom-2em
        img.col-12.block.l-margin-bottom-2em(:src="img.logo")
        .font-title-middle {{ company }}
      .col-11.m-width-100
        .col-24.textAlignLeft.m-textAlignCenter(v-for="(item, index) in address" :key="index" :class="{'l-margin-bottom-2em': index == 0}")
          .font-title-middle {{ item.name }}
          p.font-section(v-for="(i, k) in item.text" :key="k") {{ i }}

</template>

<script>
  export default {
    name: 'contactUs',
    props: ['content'],
    data(){
      return{
        company: this.$t('contact_us.company'),
        address: [
          { name: this.$t('contact_us.name_1'), text: [this.$t('contact_us.address_1'), this.$t('contact_us.tel_1'), this.$t('contact_us.email_1')] },
          { name: this.$t('contact_us.name_2'), text: [this.$t('contact_us.address_2'), this.$t('contact_us.tel_2'), this.$t('contact_us.email_2')] },
        ],
        img: {
          logo: require('@/assets/img/logo_main.png')
        }
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
